import { Component } from 'react';
import { connect } from 'react-redux';

import { convertStringToInteger } from 'common/helpers/numberHelper';
import {
  addCartQuickItem,
  removeCartItem,
  updateCartItem
} from 'redux/cart/actions';

class Variant extends Component {
  constructor(props) {
    super(props);
    const quantity = initialItemQuantity(props.cart, props.product);
    this.state = {
      quantity,
      error: null
    };
  }

  addToCart = (originalQuantity) => {
    const { props, state } = this;
    const variant = props.product.variants[0];
    const errorFunction = (error) => {
      let errMessage = 'Something went wrong';
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errMessage = error.response.data.message;
      }
      this.setState({ quantity: originalQuantity, error: errMessage });
    };
    if (state.quantity === '' || Number.isNaN(state.quantity)) {
      this.setState({ error: 'Invalid Quantity' });
    } else if (convertStringToInteger(state.quantity) < 0) {
      this.setState({ error: 'Invalid Quantity' });
    } else if (convertStringToInteger(state.quantity) === 0) {
      props.removeCartItem(variant.sku, false);
    } else if (originalQuantity > 0) {
      props.updateCartItem(
        variant.sku,
        convertStringToInteger(state.quantity),
        false,
        errorFunction
      );
    } else {
      const item = {
        quantity: convertStringToInteger(state.quantity),
        sku: variant.sku
      };
      props.addCartQuickItem(item, props.analytics, errorFunction);
    }
  };

  handleQuantity = (e) => {
    const { state } = this;
    const input = e.target.value;
    const quantity = input.replace(/[^0-9]/g, '');
    const originalQuantity = state.quantity;
    this.setState({ quantity, error: null }, () => {
      this.addToCart(originalQuantity);
    });
  };

  render() {
    const { product } = this.props;
    const { quantity, error } = this.state;
    if (!product.variants || product.variants.length === 0) {
      return null;
    }
    if (
      product.security &&
      product.security.availableTo === 'Allocation' &&
      !product.security.isValidUser
    ) {
      return null;
    }
    let minQty = 0;
    let maxQty = 1000;
    if (
      product.security &&
      product.security.availableTo === 'Allocation' &&
      product.allocations &&
      product.allocations[0]
    ) {
      minQty = product.allocations[0].minQuantity;
      maxQty =
        product.allocations[0].maxQuantity +
        product.allocations[0].additionalGrant -
        product.allocations[0].quantityPurchased;
    }
    if (maxQty - minQty <= 0) {
      return null;
    }
    if (product.type === 'Wine' && maxQty < 12) {
      return null;
    }
    return (
      <form
        action=""
        onSubmit={this.submitForm}
        className="c7-product__variant"
      >
        {error && (
          <span className="c7-product__error" aria-describedby="qtyerror">
            Error: {error}
          </span>
        )}
        <div className="c7-product__variant__add-to-cart">
          {renderInputButton(
            quantity,
            this.handleQuantity,
            minQty,
            maxQty,
            error
          )}
        </div>
      </form>
    );
  }
}

const renderInputButton = (quantity, handleQuantity, minQty, maxQty, error) => {
  let count = 24;
  if (maxQty < 10) {
    count = maxQty;
  }
  const optionArray = [];
  for (let i = 0; i <= count; i += 1) {
    optionArray.push(i);
  }
  let describedby;
  if (error) {
    describedby = { 'aria-describedby': 'qtyerror' };
  }
  return (
    <label htmlFor="quantity">
      <select
        name="quantity"
        className="c7-product__variant__add-to-cart__select"
        value={quantity}
        onChange={handleQuantity}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...describedby}
      >
        {optionArray.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </label>
  );
};

const initialItemQuantity = (cart, product) => {
  if (!cart || !cart.items || cart.items.length === 0) {
    return 0;
  }
  if (!product.variants || product.variants.length === 0) {
    return 0;
  }
  const item = cart.items.find((i) => i.sku === product.variants[0].sku);
  if (!item) {
    return 0;
  }
  return item.quantity;
};

export default connect(null, {
  addCartQuickItem,
  removeCartItem,
  updateCartItem
})(Variant);
